module.exports = __webpack_public_path__ + "static/media/mixkit-marimba-ringtone-1359.49106cb.wav";